import React, { useState, useEffect, lazy, Suspense } from "react";
import { Link, useNavigation } from "react-router-dom";
import {
  Flex,
  Popover,
  Text,
} from "@mantine/core";
import { useNavigate } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import NotificationsRoundedIcon from "@mui/icons-material/NotificationsRounded";
import AccountCircleSharpIcon from "@mui/icons-material/AccountCircleSharp";
import MenuIcon from "@mui/icons-material/Menu";
import CategCheckbox from "./custom categ checkbox";
import chooseInterest from "../utils/interests function";
import CategoriesSelect from "./input categories select";
import RefreshIcon from "@mui/icons-material/Refresh";

// the system should take you to a page with only products
//  and options to sort products and the landing page should stay the same

export default function Nav({
  mappedCart,
  realTimeData,
  mappedFavorites,
  mappedComFavorites,
  changeTerm,
  search,
  categoriesArr,
  searchTerm,
  setSearchTerm,
  signupForm,
  userId,
  userData,
}) {
  const navigate = useNavigate();
  const [selectedSection, setSelectedSection] = useState("us");

  const categoriesData = categoriesArr?.map((categ) => {
    const val = categ.replace("-", " ");
    const newWord = `${val.charAt(0).toUpperCase()}${val.slice(1)}`;
    return {
      label: newWord,
      value: newWord,
    };
    // return <option value={newWord}>{newWord}</option>;
  });
  // separate the products again and display teh com products only on the com page!!!!!!!!!!!!
  const goCheckout = () => {
    if (realTimeData.cart.length >= 1) {
      navigate("/checkout-page");
    } else {
      navigate("/");
    }
  };

  const cartValue = () => {
    let val = 0;
    if (realTimeData.cart?.length > 0) {
      val = realTimeData.cart
        ?.map((item) => +item.pPrice * +item.pQuantity)
        .reduce((a, b) => a + b)
        .toFixed(2);
    }
    return val;
  };

  const changeSelection = (e) => {
    const select = e.target.getAttribute("select");
    setSelectedSection(select);
  };

  return (
    <div className="nav-container">
      <Flex
        pt="1rem"
        pb="1rem"
        ml="5rem"
        mr="5rem"
        gap="2rem"
        align="center"
        justify="space-between"
      >
        <button onClick={() => navigate("/")} type="button">
          <img
            src="../images/buck white.svg"
            style={{
              width: "5rem",
              position: "absolute",
              transform: "translate(-2.5rem , -2.5rem)",
            }}
            alt=""
          />
        </button>
        <form onSubmit={(values) => search(values)} className="search-wrapper">
          {/* <Select
            onChange={setSearchTerm}
            clearable
            placeholder="Categories"
            maxDropdownHeight={400}
            color="red"
            size="xs"
            styles={{
              input: {
                background: "none",
                border: "none",
                borderRadius: 0,
              },
            }}
            data={categoriesData}
          /> */}
          <CategoriesSelect
            setSearchTerm={setSearchTerm}
            categoriesData={categoriesData}
            searchTerm={searchTerm}
          />
          <input
            value={searchTerm}
            onChange={(e) => changeTerm(e)}
            id="search"
            type="text"
            placeholder="Search..."
          />
          <button type="submit">
            <SearchIcon sx={{ color: "rgb(9, 30, 43)" }} />
          </button>
        </form>
        <p style={{ cursor: "pointer" }}>Customer Support</p>
        <Popover width={250} position="bottom" withArrow shadow="md">
          <Popover.Target>
            <Flex>
              {realTimeData.favorites?.length > 0 && (
                <div className="item-number">
                  <p
                    style={{
                      transform:
                        realTimeData.favorites.length < 10
                          ? "translate(3.8px, -1.8px)"
                          : "translate(.5px, -1.5px)",
                    }}
                  >
                    {realTimeData.favorites.length}
                  </p>
                </div>
              )}

              <p style={{ cursor: "pointer" }}>Favorites</p>
              <ArrowDropDownIcon style={{ cursor: "pointer" }} />
            </Flex>
          </Popover.Target>
          <Popover.Dropdown>
            <>
              <Flex mb="1rem" justify="center" w="100%">
                <div
                  style={{
                    borderBottom:
                      selectedSection === "us"
                        ? "3px solid rgb(255, 201, 26)"
                        : null,
                    color: "rgb(9, 30, 43)",
                  }}
                  onClick={changeSelection}
                  select="us"
                  className="selector"
                >
                  <p>Us</p>
                </div>
                <div
                  style={{
                    borderBottom:
                      selectedSection === "community"
                        ? "3px solid rgb(255, 201, 26)"
                        : null,
                    color: "rgb(9, 30, 43)",
                  }}
                  onClick={changeSelection}
                  select="community"
                  className="selector"
                >
                  <p>Community</p>
                </div>
              </Flex>
              {selectedSection === "us" ? (
                <Text style={{ color: "black" }}>{mappedFavorites}</Text>
              ) : (
                <Text style={{ color: "black" }}>{mappedComFavorites}</Text>
              )}
            </>
          </Popover.Dropdown>
        </Popover>

        <Popover width={250} position="bottom" withArrow shadow="md">
          <Popover.Target>
            <Flex>
              {realTimeData.cart?.length > 0 && (
                <div className="item-number">
                  <p
                    style={{
                      transform:
                        realTimeData.cart.length < 10
                          ? "translate(3.8px, -1.8px)"
                          : "translate(.5px, -1.5px)",
                    }}
                  >
                    {realTimeData.cart.length}
                  </p>
                </div>
              )}
              <p style={{ cursor: "pointer" }}>Cart</p>
              <ArrowDropDownIcon style={{ cursor: "pointer" }} />
            </Flex>
          </Popover.Target>
          <Popover.Dropdown>
            <Text size="sm">{mappedCart}</Text>
            {realTimeData.cart?.length <= 0 && (
              <p style={{ color: "black" }}>Nothing here!</p>
            )}
            <Flex justify="space-between" align="center">
              <button className="checkout-button" onClick={goCheckout}>
                CHECKOUT
              </button>
              <p style={{ color: "rgb(9, 30, 43)" }}>€{cartValue()}</p>
            </Flex>
          </Popover.Dropdown>
        </Popover>
        <Flex>
          {/*NOTIFICATIONS BUBBLE*/}
          {/* {realTimeData.cart?.length > 0 && (
            <div className="item-number-notif">
              <p
                style={{
                  transform:
                    realTimeData.cart.length < 10
                      ? "translate(3.8px, -1.8px)"
                      : "translate(.5px, -1.5px)",
                }}
              >
                {realTimeData.cart.length}
              </p>
            </div>
          )} */}
          <NotificationsRoundedIcon
            style={{ cursor: "pointer" }}
            sx={{ fontSize: "2rem" }}
          />
        </Flex>
        <Link style={{ color: "white" }} to="/my-account">
          <AccountCircleSharpIcon sx={{ fontSize: "3rem" }} />
        </Link>
      </Flex>
      {/* --------------------------------- */}
      <div className="nav-options">
        <Flex
          mr="5rem"
          ml="5rem"
          pt="1rem"
          pb="1rem"
          style={{
            cursor: "pointer",
            borderTop: "1px solid rgb(255, 201, 26)",
          }}
          align="center"
          gap="3rem"
        >
          <Popover width={200} position="bottom" withArrow shadow="md">
            <Popover.Target>
              <Flex gap={5} align="center">
                <MenuIcon />
                <p>SELECT INTERESTS</p>
              </Flex>
            </Popover.Target>
            <Popover.Dropdown>
              <Flex justify="flex-end">
                <button
                onClick={() => window.location.reload()}
                style={{padding: "3px 10px"}}
                className="blue-gradient-button-outlined"
                  // style={{ background: "none", border: "none", cursor: "pointer" }}
                  type="button"
                >
                  <Flex h="1em" align="center">
                    <Text weight="500" size="15px">Apply</Text>
                    <RefreshIcon style={{ fontSize: "19px", marginTop: "3px" }} />
                  </Flex>
                </button>
              </Flex>
              {categoriesArr.sort()?.map((categ, i) => {
                const val = categ.replace("-", " ");
                const newWord = `${val.charAt(0).toUpperCase()}${val.slice(1)}`;
                return (
                  <Flex key={i} align="end" justify="space-between">
                    <Text
                      onClick={() => chooseInterest(categ, userId, userData)}
                      className="categ-hover"
                      style={{ marginTop: 5 }}
                      color="black"
                    >
                      {newWord}
                    </Text>
                    <CategCheckbox
                      realTimeData={realTimeData}
                      userData={userData}
                      categ={categ}
                      userId={userId}
                    />
                  </Flex>
                );
              })}
            </Popover.Dropdown>
          </Popover>
          <Link
            style={{ textDecoration: "none", color: "white" }}
            to="/community-sellings"
          >
            <p>SOLD BY COMMUNITY</p>
          </Link>
          <p>I FEEL LUCKY</p>
        </Flex>
      </div>
    </div>
  );
}
